import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast glass-surface group-[.toaster]:!bg-transparent group-[.toaster]:text-foreground group-[.toaster]:!border-primary/15 group-[.toaster]:shadow-2xl group-[.toaster]:shadow-primary/10",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success: "group-[.toast]:!border-success/25",
          error: "group-[.toast]:!border-destructive/25",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
